// /src/renderer/app/store.ts
import { configureStore } from '@reduxjs/toolkit';
// import createSagaMiddleware from 'redux-saga';
import {rootReducer} from './rootReducer';
import { listener } from './listenerMiddleware';
// import { listener } from './listenerMiddleware';
// import rootSaga from './rootSaga';
// import { listener } from './listenerMiddleware';

// const sagaMiddleware = createSagaMiddleware();

type Provider = () => Promise<string>; // PNG dataURL

const reg = new WeakMap<HTMLCanvasElement, Provider>();

export function registerCanvasCapture(
  canvas: HTMLCanvasElement,
  provider: Provider
) {
  reg.set(canvas, provider);
}

export function getCanvasCaptureProvider(
  canvas: HTMLCanvasElement
): Provider | undefined {
  return reg.get(canvas);
}


export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listener.middleware)
});
